import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortComponent } from './sort.component';
import { WidgetsModule } from '../../widgets/widgets.module';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule
    ],
    declarations: [
        SortComponent,
    ],
    exports: [
        SortComponent,
    ],
    providers: []
})
export class SortModule {

}
